import { FC } from 'react';
import { IRtpProgressMetric } from '../../../../models/injury';
import { ChartEmptyState } from './_shared/ChartEmptyState';
import styles from '../AthleteInjuryCharts.module.scss';

interface Props {
  data: IRtpProgressMetric | null;
  period?: string;
}

export const RtpProgressChart: FC<Props> = ({ data }) => {
  if (!data) {
    return <ChartEmptyState />;
  }

  const pct = Math.min(100, Math.max(0, data.pct ?? 0));

  return (
    <div className={styles.rtpCard}>
      <div className={styles.rtpTypeLine}>
        Tipo infortunio: <span className={styles.rtpTypeValue}>{data.injuryType}</span>
      </div>
      <div className={styles.rtpTrack}>
        {/* Larghezza proporzionale al progresso: valore runtime, non tokenizzabile. */}
        <div className={styles.rtpFill} style={{ width: `${pct}%` }} />
      </div>
      <div className={styles.rtpFooter}>
        <span>
          Fase {data.phase}/{data.totalPhases}
        </span>
        <span className={styles.rtpFooterPct}>{pct.toFixed(0)}%</span>
      </div>
    </div>
  );
};
